import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { InspectionListItem, PaginatedResponse } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchInspectionsParams } from '../api';
import { createInspectionApi, inspectionKeys } from '../api';

/** Runs the paginated inspection search that backs one tab of the Inspections list (SWOOP-400). */
export function useInspectionsSearch(
  params: SearchInspectionsParams,
): UseQueryResult<PaginatedResponse<InspectionListItem>> {
  const client = useApiClient('admin-auth');
  const api = createInspectionApi(client);

  return useQuery({
    gcTime: 5 * 60_000,
    queryFn: () => api.search(params),
    queryKey: inspectionKeys.search(params),
    staleTime: 30_000,
  });
}
